import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import ShopType from "@/enum/ShopType";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { saveShopHideCarInfo, setOrderItemColorSizeSorting, ShopAdvancedSettingDto } from "@/services/api/shop";
import { useGlobalStore } from "@/store/hooks";
import { useRequest } from "ahooks";
import { Checkbox, message, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { getDefaultOrderSortOptions } from "../../OrderSortSelect/util";
import OrderSort from "@/scenes/OrderManagement/enum/OrderSort";

interface OrderSettingProps {
    shopSetting: ShopSettingDTO;
    shopAdvancedSetting: ShopAdvancedSettingDto;
}

/**
 * - 当前车型设置(唯一配置项)仅在淘宝平台生效
 */
const OrderSetting: React.FC<OrderSettingProps> = function (props) {
    const { shopSetting, shopAdvancedSetting } = props;
    const { id: shopId } = shopSetting;
    const { shopAdvancedSettingStore } = useGlobalStore();
    const orderManagementStore = useOrderManagementStore();
    const [hideCarInfo, updateHideCarInfo] = useState(shopAdvancedSetting.hideCarInfo);
    const [enabledOrderItemColorSizeSorting, updateEnabledOrderItemColorSizeSorting] = useState(
        shopAdvancedSetting.enabledOrderItemColorSizeSorting,
    );

    const { runAsync: saveHieCarInfo, loading: loading1 } = useRequest(
        async (enabled: boolean) => {
            const setting = await saveShopHideCarInfo(shopId, enabled);

            shopAdvancedSettingStore.setAdvancedSetting(shopId, setting);

            updateHideCarInfo(enabled);

            orderManagementStore.fetchOrders(shopId);
        },
        { manual: true },
    );

    async function handleHideCarInfoChange(e) {
        const enabled = e.target.checked;

        await saveHieCarInfo(enabled);

        message.success("保存成功");
    }

    const { runAsync: saveOrderItemColorSizeSorting, loading: loading2 } = useRequest(
        async (enabled: boolean) => {
            const setting = await setOrderItemColorSizeSorting(shopId, enabled);

            shopAdvancedSettingStore.setAdvancedSetting(shopId, setting);

            updateEnabledOrderItemColorSizeSorting(enabled);

            orderManagementStore.fetchOrders(shopId);
        },
        { manual: true },
    );

    async function handleOrderItemColorSizeSortingChange(e) {
        const enabled = e.target.checked;

        if (!enabled && orderManagementStore.table.listOptions.orderSort === OrderSort.PRODUCT_SKU_COLOR_SIZE) {
            const defaultOrderSortOptions = getDefaultOrderSortOptions(shopSetting.type, orderManagementStore.tab);
            orderManagementStore.table.changeOrderSort(shopId, orderManagementStore.tab, defaultOrderSortOptions[0]);
        }

        await saveOrderItemColorSizeSorting(enabled);

        message.success("保存成功");
    }

    const loading = loading1 || loading2;

    return (
        <Spin spinning={loading}>
            {shopSetting.type === ShopType.TAOBAO ? (
                <div>
                    <Checkbox checked={hideCarInfo} onChange={handleHideCarInfoChange}>
                        不再显示商品车型信息
                    </Checkbox>
                </div>
            ) : null}

            <div>
                <Checkbox checked={enabledOrderItemColorSizeSorting} onChange={handleOrderItemColorSizeSortingChange}>
                    <span>开启自动识别商品属性颜色尺码</span>
                    <span className="text-gray">(用于订单列表按相同商品颜色尺码排序)</span>
                </Checkbox>
            </div>
        </Spin>
    );
};

export default observer(OrderSetting);
